
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSecureAdminManagement } from '../hooks/useSecureAdminManagement';
import AuditMonitorDashboard from '../components/audit/AuditMonitorDashboard';
import BottomTabNavigation from '../components/navigation/BottomTabNavigation';
import { Card, CardContent } from '../components/ui/card';
import { Shield } from 'lucide-react';

const AuditMonitorPage = () => {
  const { t } = useTranslation();
  const { isAdmin } = useSecureAdminManagement();

  if (!isAdmin) {
    return (
      <div className="min-h-screen flex flex-col">
        <div className="flex-1 container mx-auto max-w-4xl p-4">
          <Card>
            <CardContent className="flex items-center justify-center py-12">
              <div className="text-center">
                <Shield className="h-12 w-12 text-yellow-500 mx-auto mb-4" />
                <h3 className="text-lg font-semibold mb-2">{t('auditMonitor.accessDenied')}</h3>
                <p className="text-muted-foreground">
                  {t('auditMonitor.adminOnly')}
                </p>
              </div>
            </CardContent>
          </Card>
        </div>
        <BottomTabNavigation />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <div className="flex-1 container mx-auto max-w-7xl p-4">
        <AuditMonitorDashboard />
      </div>
      <BottomTabNavigation />
    </div>
  );
};

export default AuditMonitorPage;
